import React, { useEffect, useState } from "react";
import './style.css';
import {
  Button,
  Input,
  Row,
  Col,
  Form,
  Modal,
  Spin
} from "antd";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  SyncOutlined,
  WindowsFilled
} from "@ant-design/icons";

import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { UserEditPassword, editPasswordSelector, clearState } from './EditPasswordSlice';
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const tailLayout = {
  wrapperCol: { span: 24, offset: 0 }
};


export default function EditPassword() {

  const dispatch = useDispatch();
  const [isLoading, setLoading] = React.useState(false);
  const [isToast, setToast] = React.useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const { isFetching, isEditSuccess, isError, errorMessage } = useSelector(
    editPasswordSelector
  );

  useEffect(() => {
    setToast(false);
    dispatch(clearState());
  }, []);

  useEffect(() => {

    if (isError) {
      dispatch(clearState());
      setToast(true);
      toast.error(errorMessage);
    }
    if (isEditSuccess) {
      dispatch(clearState());
      form.resetFields();
      setToast(true);
      toast.success(errorMessage);
      setIsModalVisible(false);
    setTimeout(setToast(false),2000)
    }
  }, [isError, isEditSuccess, setLoading, setToast]);


  const onFinish = (values) => {
    let data = {
      // "currentpassword": values.currentpassword,
      "password": values.newpassword,
      // "confirmpassword": values.confirmpassword,
    };
    dispatch(UserEditPassword(data));
    window.location.reload();
  };

  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
  };


  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    dispatch(clearState());
    form.resetFields();
    setIsModalVisible(false);
  };


  return (
    <>
      {/* <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} /> */}
      {isToast &&
        <Toaster
          toastOptions={{
            className: '',
            style: {
              border: '1px solid #713200',
              padding: '16px',
              color: '#713200',
              marginTop: 50
            },
          }}
        >
          {(t) => (
            <ToastBar toast={t}>
              {({ icon, message }) => (
                <>
                  {icon}
                  {message}
                  {t.type !== 'loading' && (
                    <button onClick={() => toast.dismiss(t.id)}>X</button>
                  )}
                </>
              )}
            </ToastBar>
          )}
        </Toaster>
      }

      <Button type="link" style={{ color: "#000", fontWeight: 500 }} onClick={showModal} >Edit Password</Button>
      <Modal width={500} className="edit-password-modal" centered cancelButtonProps={{ style: { display: 'none' } }} okButtonProps={{ style: { display: 'none' } }} title="" visible={isModalVisible} onCancel={handleCancel}>
        <div className="title-sec">
          <h2 style={{ margin: '0px' }}>Edit Password</h2>
        </div>
        <Row className="form-row" style={{ marginTop: '0px !important' }}>
          <Col span="24">
            <Form
              className="login-form"
              name="basic"
              layout="vertical"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >

              {/* <Form.Item
                label="Enter Current Password"
                name="currentpassword"
                rules={[
                  {
                    required: true,
                    message: 'Please enter current password',
                  },
                  { min: 8, message: 'Password must have a minimum length of 8' },
                  {
                    pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$'),
                    message: 'Password must contain at least one lowercase letter, uppercase letter, number, and special character'
                  }
                ]}
                requiredMark={'optional'}
              >
                <Input.Password
                  placeholder={""} value="" autoComplete="off"
                  className="formInput"
                  iconRender={visible => (visible ? <EyeTwoTone style={{ color: '#000', fontSize: 24 }} /> : <EyeInvisibleOutlined style={{ color: '#000', fontSize: 24 }} />)}
                />
              </Form.Item> */}

              <Form.Item
                label="New Password"
                name="newpassword"
                rules={[
                  {
                    required: true,
                    message: 'Please enter new password',
                  },
                  { min: 8, message: 'Password must have a minimum length of 8' },
                  {
                    pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$'),
                    message: 'Password must contain at least one lowercase letter, uppercase letter, number, and special character'
                  }
                ]}
                requiredMark={'optional'}
              >
                <Input.Password
                  placeholder={""} value="" autoComplete="off"
                  className="formInput"
                  iconRender={visible => (visible ? <EyeTwoTone style={{ color: '#000', fontSize: 24 }} /> : <EyeInvisibleOutlined style={{ color: '#000', fontSize: 24 }} />)}
                />
              </Form.Item>


              <Form.Item
                label="Confirm New Password"
                name="confirmpassword"
                requiredMark={'optional'}
                dependencies={['newpassword']}
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your new password!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('newpassword') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('The two passwords that you entered do not match!'));
                    },
                  }),
                ]}
              >
                <Input.Password
                  placeholder={""} value="" autoComplete="off"
                  className="formInput"
                  iconRender={visible => (visible ? <EyeTwoTone style={{ color: '#000', fontSize: 24 }} /> : <EyeInvisibleOutlined style={{ color: '#000', fontSize: 24 }} />)}
                />
              </Form.Item>

              <Form.Item className="action-buttons" {...tailLayout}>
                <Button htmlType="submit" type="primary" className="login-btn">Confirm</Button>
                <Button htmlType="submit" type="" className="login-btn cancel-btn" onClick={handleCancel}>Cancel</Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Modal>
    </>
  );
}
